import { render, staticRenderFns } from "./MailTemplateForm.vue?vue&type=template&id=0dbcba66&scoped=true"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateForm.vue?vue&type=style&index=0&id=0dbcba66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcba66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbcba66')) {
      api.createRecord('0dbcba66', component.options)
    } else {
      api.reload('0dbcba66', component.options)
    }
    module.hot.accept("./MailTemplateForm.vue?vue&type=template&id=0dbcba66&scoped=true", function () {
      api.rerender('0dbcba66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/MailTemplateForm.vue"
export default component.exports